// extracted by mini-css-extract-plugin
module.exports = {"topLeaguesList":"upcoming-live-tournaments_topLeaguesList__wNZBA"};